var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "send-app" },
    [
      _c(
        "transition-group",
        { attrs: { name: "slide-fade" } },
        [
          !_vm.isSend
            ? _c("v-content-section", {
                key: "content-section-before-send",
                attrs: { content: _vm.content[0], variant: "black" }
              })
            : _c("v-content-section", {
                key: "content-section-send",
                attrs: { content: _vm.content[1], variant: "black" }
              })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "modal-form" },
        [
          _c("v-typo", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isSend,
                expression: "isSend"
              }
            ],
            class: [
              "modal-form__again",
              {
                "modal-form__again--active": _vm.isSend
              }
            ],
            attrs: { variant: "body-perex" },
            domProps: { innerHTML: _vm._s(_vm.$t("success.again")) }
          }),
          _vm._v(" "),
          _c("v-phone-select", {
            staticClass: "modal-form__phone",
            attrs: { "button-label": "button.getAppLink", variant: "blue" },
            on: {
              send: function($event) {
                _vm.isSend = true
              }
            }
          }),
          _vm._v(" "),
          _c("v-typo", {
            staticClass: "modal-form__safety",
            attrs: { variant: "body-small" },
            domProps: {
              innerHTML: _vm._s(
                _vm.$t("download.safety", {
                  link:
                    _vm.getPdfPath + "20220612_Skatra_ApS_Privacy_Policy.pdf"
                })
              )
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }